import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextBold } from 'UiKit/typography';

import styles from './styles.module.css';

const Head = () => {
  const { t } = useTranslation('schedule-ruleset');
  return (
    <Box className={styles['head-schedule-ruleset__container']}>
      <TextBold className={styles['head-schedule-ruleset__title']}>{t('title')}</TextBold>
    </Box>
  );
};

export default Head;
